module.exports = __webpack_public_path__ + "img/stand_ruoyi_idle.865296e5.jpg";